<template>
    <section>
        <header class="modal-card-head is-radiusless">
            <h5 class="title is-5">Update Task "{{ task.taskText }}"</h5>
        </header>
        <section class="modal-card-body">
            <n-form-item required label="Status">
                <n-select :status="!formData.status ? 'error' : undefined" :options="taskStatusOptions" v-model:value="formData.status" />
            </n-form-item>
            <n-form-item label="Date">
                <condo-date-picker type="date" v-model="formData.statusUpdatedAt" :clearable="true" />
            </n-form-item>
        </section>
        <footer class="modal-card-foot">
            <div class="is-flex is-justify-content-end is-fullwidth">
                <n-button-group>
                    <condo-button icon-left="window-close" @click="emit('close')" type="is-default" ghost size="small">Close</condo-button>
                    <condo-button icon-left="save" @click="save()" type="is-primary" size="small">Update</condo-button>
                </n-button-group>
            </div>
        </footer>
    </section>
</template>

<script setup lang="ts">
import { ITask, TaskStatusTranslation } from '@condo/domain';
import { ref } from 'vue';
import { NButtonGroup, NSelect, NFormItem } from 'naive-ui';
import { TaskStatus } from '@condo/domain';
import { enumToHuman } from '@/shared/filters';

interface Props {
    task: Partial<ITask>;
}

interface Emits {
    (ev: 'close'): void;
    (ev: 'save', data: { status?: TaskStatus; statusUpdatedAt?: Date }): void;
}

const props = defineProps<Props>();
const emit = defineEmits<Emits>();

const taskStatusOptions = Object.values(TaskStatus).map(status => ({
    label: TaskStatusTranslation[status as TaskStatus] || enumToHuman(status),
    value: status,
}));

const formData = ref({
    status: props.task.status,
    statusUpdatedAt: new Date(),
});

const save = () => {
    if (!formData.value.status) {
        return;
    }

    emit('save', formData.value);
};
</script>

<style scoped></style>
